import { render, staticRenderFns } from "./BHeader.vue?vue&type=template&id=ce3169c4&scoped=true"
import script from "./BHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BHeader.vue?vue&type=style&index=0&id=ce3169c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3169c4",
  null
  
)

export default component.exports